import React, { useEffect } from 'react'
import Box from "@mui/material/Box";
import CompanyProfileView from '../../../components/CompanyProfileView/CompanyProfileView';

const CompanyProfile = () => {
  useEffect(() => {
      window.scrollTo(0, 0);
    }, []);
  return (
    <>    
      <Box className="page-background">
         <CompanyProfileView />
      </Box>
    </>
  )
}

export default CompanyProfile